<template>
  <tr class="table-row">
    <td>{{ tripDateDisplay }}</td>
    <td v-if="isInternal">{{ item.student?.internal_id }}</td>
    <td>{{ item.student?.public_id }}</td>
    <td>{{ studentName }}</td>
    <td>{{ item.requesting_district }}</td>
    <td>{{ directionDisplay }}</td>
    <td>{{ item.school }}</td>

    <td class="address-cell">
      <div v-if="item.pickup_location_name">
        {{ item.pickup_location_name }}
      </div>
      <div>{{ item.pickup_address?.street }}</div>
      <div>{{ cityStateZip(item.pickup_address) }}</div>
      <div v-if="item.pickup_time">
        {{ timeDisplay(item.pickup_time) }}
      </div>
    </td>

    <td class="address-cell">
      <div v-if="item.dropoff_location_name">
        {{ item.dropoff_location_name }}
      </div>
      <div>{{ item.dropoff_address?.street }}</div>
      <div>{{ cityStateZip(item.dropoff_address) }}</div>
      <div v-if="item.dropoff_time">
        {{ timeDisplay(item.dropoff_time) }}
      </div>
    </td>
    <td>{{ item.vendor_name }}</td>
  </tr>
</template>

<script>
export default {
  name: 'OneTimeRideItem',

  props: {
    item: {
      type: Object,
      required: true,
    },

    isInternal: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    studentName() {
      if (!this.item.student) return ''

      return [
        this.item.student.first_name,
        this.item.student.middle_name,
        this.item.student.last_name,
      ]
        .filter(Boolean)
        .join(' ')
    },

    tripDateDisplay() {
      if (!this.item.trip_date) return ''

      return new Date(`${this.item.trip_date}T00:00:00`).toLocaleDateString(
        'en-US'
      )
    },

    directionDisplay() {
      if (this.item.is_inbound === true) {
        return 'Inbound'
      }

      if (this.item.is_inbound === false) {
        return 'Outbound'
      }

      return ''
    },
  },

  methods: {
    timeDisplay(value) {
      if (!value) return ''

      const [hourValue, minute] = value.split(':')
      let hour = parseInt(hourValue)

      const suffix = hour >= 12 ? 'PM' : 'AM'

      hour %= 12
      hour = hour || 12

      return `${hour}:${minute} ${suffix}`
    },

    cityStateZip(address) {
      if (!address) return ''

      return [
        address.city,
        [
          address.state,
          address.zip_code,
        ]
          .filter(Boolean)
          .join(' '),
      ]
        .filter(Boolean)
        .join(', ')
    },
  },
}
</script>

<style scoped>
.address-cell {
  width: 140px;
  max-width: 140px;
  white-space: normal;
  overflow-wrap: break-word;
}

.table-row:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
